<template>
  <div class="folder-viewer">
    <ul
      class="folder-list"
      :class="{
        'drag-start': dragEnable,
      }"
    >
      <!--Folder Actions-->
      <li
        class="item back-button"
        :class="{ disabled: !activeFolderId }"
        data-toggle="tooltip"
        data-trigger="hover"
        @click="load(getParentFolders.slice().reverse()[1].id)"
        @dragenter="folderDragEnter"
        @dragleave="folderDragLeave"
        @drop="folderDrop($event, getParentFolders.slice().reverse()[1])"
        title="Geri"
      >
        <div class="icon"><i class="icon-arrow-left8"></i></div>
      </li>

      <!--Folder Items-->
      <li
        class="item"
        @dblclick="load(folder.id)"
        v-for="(folder, index) in folders"
        @dragover="$event.preventDefault()"
        @dragenter="folderDragEnter"
        @dragleave="folderDragLeave"
        @drop="folderDrop($event, folder)"
      >
        <div class="icon"><i class="icon-folder"></i></div>
        <div class="title">{{ folder.name }}</div>
        <div class="buttons">
          <a @click="exportFolder(folder)" href="#!" draggable="false"
            ><i class="icon-file-excel"></i
          ></a>
          <a @click="editShow(folder)" href="#!" draggable="false"
            ><i class="icon-pencil3"></i
          ></a>
          <a @click="remove(folder, index)" href="#!" draggable="false"
            ><i class="icon-trash"></i
          ></a>
        </div>
      </li>

      <!--Add New Folder Button-->
      <li class="item create" @click="createShow" draggable="false">
        <div class="icon"><i class="icon-folder-plus"></i></div>
        <div class="title">{{ "Yeni Klasör" | trans }}</div>
      </li>
    </ul>

    <!--Add|Edit Modal-->
    <div id="editModal" class="modal fade">
      <div class="modal-dialog modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header py-3 bg-light">
            <h4
              class="modal-title d-flex align-items-center"
              v-if="formSelected"
            >
              <i class="icon-pencil3 icon-2x mr-2 pr-1"></i
              >{{ "Klasör Düzenle" | trans }}
            </h4>
            <h4 class="modal-title d-flex align-items-center" v-else>
              <i class="icon-folder-plus2 icon-2x mr-2 pr-1"></i
              >{{ "Klasör Ekle" | trans }}
            </h4>
            <button type="button" data-dismiss="modal" class="close">×</button>
          </div>
          <div class="modal-body">
            <div class="form-group row mb-0">
              <label class="col-sm-3 col-form-label">{{
                "Klasör Adı:" | trans
              }}</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="formFolderName"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ "İptal" | trans }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveForm(formSelected || activeFolderId)"
            >
              {{ "Kaydet" | trans }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dynamicContentMixin } from "../../mixins/dynamicContent";

export default {
  name: "FolderViewer",
  props: ["api", "apiBase"],
  data() {
    return {
      activeFolderId: null,
      parentFolders: [],
      breadcrumbs: null,
      folders: [],
      formMethod: null,
      formSelected: null,
      formFolderName: null,
      dragEnable: false,
      dragElement: null,
    };
  },
  computed: {
    getParentFolders() {
      return [
        {
          id: "",
          name: "Root",
        },
      ].concat(this.parentFolders);
    },
  },
  watch: {
    folders() {
      if (!this.breadcrumbs) {
        this.breadcrumbs = document.querySelector("[data-folders]");
        this.breadcrumbs.addEventListener("click", (e) => {
          if (e.target.hasAttribute("data-folder-id")) {
            this.load(e.target.getAttribute("data-folder-id"));
          }
        });
      }

      this.breadcrumbs.innerHTML =
        "[ " +
        this.getParentFolders
          .map(
            (item) =>
              `<a href="#!" data-folder-id="${item.id}">${item.name}</a>`
          )
          .join(" / ") +
        " ]";
    },
  },
  mixins: [dynamicContentMixin],
  mounted() {
    // Load Folders using Get Parameter
    this.activeFolderId = new URLSearchParams(window.location.search).get(
      "folder_id"
    );
    this.load(this.activeFolderId);
  },
  methods: {
    /**
     * Load Folder List
     */
    load(folderId) {
      let api = folderId ? this.api + `/${folderId}` : this.api;

      // Change URL
      let query = new URLSearchParams(window.location.search);
      query.set("folder_id", folderId || "");
      history.replaceState(null, null, "?" + query.toString());
      window.initDynamicContent = this.activateDocumentDrag;
      this.loadDynamicContent(window.location.href);

      // Change Upload & Active Folder
      this.activeFolderId = folderId ?? null;
      this.changeUploadFolderId(folderId);

      // Load Data
      $.getJSON(api, (response) => {
        this.folders = response.data.folders;
        this.parentFolders = response.data.parents || [];
      });
    },

    /**
     * Show Create Form
     */
    createShow() {
      this.formSelected = null;
      this.formFolderName = null;
      this.formMethod = "POST";
      $("#editModal").modal("show");
    },

    /**
     * Show Editor Form
     */
    editShow(folder) {
      this.formSelected = folder;
      this.formFolderName = folder.name;
      this.formMethod = "PUT";
      $("#editModal").modal("show");
    },

    /**
     * Save Create|Edit Form
     */
    saveForm(folder) {
      let folderId = folder instanceof Object ? folder.id : folder;

      $.ajax({
        url: folderId ? this.api + `/${folderId}` : this.api,
        type: this.formMethod,
        dataType: "json",
        data: { name: this.formFolderName },
        success: (response) => {
          Lagina.notifySuccess(this.trans("İşlem tamamlandı."));

          let index = this.folders.findIndex((item) => item.id === folderId);
          if (index !== -1) {
            return (this.folders[index].name = response.data.name);
          } else {
            this.folders.push(response.data);
          }
        },
        error: (response) => {
          Lagina.notifyError(response.responseJSON.message);
        },
        complete: () => {
          $("#editModal").modal("hide");
        },
      });
    },

    /**
     * Remove Folder
     */
    remove(folder, index) {
      if (
        confirm(
          this.trans(
            `:name klasörünü silmek istediğinizden emin misiniz?`
          ).replace(":name", folder.name)
        )
      ) {
        $.ajax({
          url: this.api + `/${folder.id}`,
          type: "DELETE",
          dataType: "json",
          success: (response) => {
            Lagina.notifySuccess(response.message);
            this.folders.splice(index, 1);
          },
          error: (response) => {
            Lagina.notifyError(response.statusText);
          },
        });
      }
    },

    /**
     * File Upload Change Folder ID
     */
    changeUploadFolderId(folderId) {
      window.uploadFolderId = folderId || null;
    },

    /**
     * Export Document List
     */
    exportFolder(folder) {
      if (
        confirm(
          this.trans(
            ":name klasöründe bulunan dosya listesini dışa aktarmak istediğinizden emin misiniz?"
          ).replace(":name", folder.name)
        )
      ) {
        window.open(this.apiBase + "/export/" + folder.id, "_blank");
      }
    },

    /**
     * Document Drag Event
     */
    activateDocumentDrag() {
      // Enable Document Draggable
      let documents = document.querySelectorAll(".fileman-files-list > div");
      documents.forEach((document) => {
        document.setAttribute("draggable", true);
        document.addEventListener("dragstart", (e) => {
          this.dragEnable = true;
          this.dragElement = document;
        });
        document.addEventListener("dragend", (e) => {
          this.dragEnable = false;
          this.dragElement = null;
        });
      });

      // Disable Link|Img Draggable
      $(".fileman-file a, .fileman-file img").attr("draggable", false);
    },

    /**
     * Document Dropped to Folder
     */
    folderDrop(e, folder) {
      e.preventDefault();
      this.folderDragLeave(document.querySelector(".item.drag-over"));

      if (this.dragElement) {
        let elInstance = this.dragElement;
        let documentId = elInstance.getAttribute("data-id");

        $.ajax({
          url: this.apiBase + `/move/${documentId}/${folder.id}`,
          type: "POST",
          dataType: "json",
          success: (response) => {
            Lagina.notifySuccess(response.message);
            elInstance.remove();
          },
          error: (response) => {
            Lagina.notifyError(response.responseJSON.message);
          },
        });
      }
    },

    /**
     * Document Over Folder
     */
    folderDragEnter(e) {
      e.currentTarget.classList.add("drag-over");
    },

    /**
     * Document Leave Folder
     */
    folderDragLeave(e) {
      (e.currentTarget || e).classList.remove("drag-over");
    },
  },
};
</script>

<style lang="scss">
$color: #0a6ebd;
.folder-viewer {
  margin-bottom: 1.25rem;

  .folder-list {
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;

    .item {
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding: 1rem;
      text-align: center;
      border-radius: 0.25rem;
      cursor: pointer;
      transition: 0.2s all;
      position: relative;
      min-width: 120px;
      max-width: 150px;
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      &.create {
        min-width: auto;
        max-width: 120px;
        opacity: 0.7;
      }

      &.back-button {
        max-width: 50px;
        min-width: auto;

        i {
          font-size: 1.4rem !important;
          margin-bottom: 0 !important;
        }

        &.disabled {
          opacity: 0.7;
          pointer-events: none;
        }
      }

      &:hover {
        border-color: #0a6ebd;
        opacity: 1;

        .icon i,
        .title {
          opacity: 1;
        }

        .buttons {
          opacity: 1;
          transition: opacity 0.1s ease-in 0.5s;
        }
      }

      .icon i {
        transition: 0.2s all;
        font-size: 2rem;
        margin-bottom: 0.5rem;
      }

      .icon i,
      .title {
        opacity: 0.75;
        transition: 0.2s all;
      }

      .title {
        font-size: 14px;
        user-select: none;
      }

      .buttons {
        opacity: 0;
        display: flex;
        position: absolute;
        right: 0.4rem;
        top: 0.4rem;
        transition: opacity 0.2s ease-out;

        a {
          color: #555;
          transition: 0.2s all;
          border-radius: 50%;
          width: 25px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.5;

          &:hover {
            opacity: 1;
            color: $color;
            background: lighten($color, 55%);
          }
        }

        i {
          font-size: 0.85rem;
        }
      }
    }

    &.drag-start {
      li.item:not(.create) {
        box-shadow: 0 0 0 1px rgb(118 85 169);

        & > div {
          pointer-events: none;
        }

        &.drag-over {
          box-shadow: 0 0 0 3px rgb(118 85 169);
          transform: scale(1.025);
        }
      }
    }
  }
}

/**
 * Folder Breadcrubs Disable Last Element
 */
[data-folders] {
  a:last-child {
    pointer-events: none;
    color: #999;
  }
}

/**
 *
 */
.fileman-file {
  cursor: move;
}
</style>
